import { apiV2 } from '../services';
export const verifyHumanity = async () => {
    const response = await apiV2.antibot.verifyHumanity();
    if (response.status !== 200) {
        throw new Error(`Failed to verify humanity: ${response.body}`);
    }
    return response.body;
};
